<template>
    <b-card :header="uLang('app.on_going_trajectories')" header-tag="h4" class="all-trajectories bg-default-card">
        <rea-loader class="" :loading="loading"></rea-loader>
        <table class="trajectories-table table">
            <tr v-if="hasTrajectories">
                <td colspan="4">{{ uLang('app.empty_table') }}</td>
            </tr>
            <tr v-if="cardData.length > 0">
                <th>{{ uLang('app.trajectory') }}</th>
                <th>{{ uLang('app.candidate') }}</th>
                <th>{{ uLang('app.start_date') }}</th>
                <th>{{ uLang('app.end_date') }}</th>
                <th></th>
            </tr>
            <tr v-if="cardData.length > 0" v-for="trajectoryEnrolment in cardData">
                <td><router-link :to="{
                        name: 'admin.relations.trajectory-enrolments.view',
                        params: {
                            'relationId': trajectoryEnrolment.relation_id,
                            'trajectoryEnrolmentId': trajectoryEnrolment.id,
                        }
                    }">
                    {{ trajectoryEnrolment.trajectory.name }}
                    </router-link></td>
                <td>{{ trajectoryEnrolment.relation.full_name }}</td>
                <td>{{ trajectoryEnrolment.trajectory_start_date | date }}</td>
                <td>{{ trajectoryEnrolment.trajectory_end_date | date }}</td>
                <td></td>
            </tr>
        </table>
    </b-card>
</template>
<script>
    import { ReaLoader } from '~/components/helpers'
    export default {
        name: 'UpcomingActionDocuments',

        components: {
            ReaLoader
        },

        props: {
            actionDocuments: {
                required: true,
            },
            loading: {
                required: true,
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                emptyPanel: {
                    'trajectory': {
                        'name': uLang('app.no_trajectory'),
                    },
                    'reporting_person': {
                        'full_name': uLang('app.no_name'),
                    },
                    'trajectory_start_date': uLang('app.no_start_date'),
                    'trajectory_end_date': uLang('app.no_end_date'),
                },
            }
        },

        methods: {

        },

        computed: {
            cardData() {
                if(this.hasTrajectories) {
                    return this.emptyPanel
                }

                return this.actionDocuments
            },
            hasTrajectories() {
                return _.isEmpty(this.actionDocuments)
            }
        },
    }
</script>
<style lang="scss">
    table.trajectories-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }
</style>
